import type React from 'react';
import { useEnvSuspense } from '#admin/hook/useEnv.tsx';

type Props = {
  children: React.ReactNode;
};

export const AppDataProvider: React.FC<Props> = ({ children }) => {
  // Trigger the env data fetch with suspense
  useEnvSuspense();

  return children;
};
